module.exports = __webpack_public_path__ + "static/img/icon-login.a4298b5.png";